export const pageType = {
  login: 'main',
  signIn: 'signin',
};
